import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import logo from "../assets/Light.png";

const missions = [
  { label: "Branding", path: "/branding" },
  { label: "UI/UX", path: "/ui-ux" },
  { label: "SEO & GEO", path: "/seo-geo" },
  // { label: "Marketing", path: "#" },
  { label: "Production & Post-production", path: "/production-post-production" },
];

export default function Header({ visible = true }) {
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);
  const [missionsOpen, setMissionsOpen] = useState(false);

  // close dropdown on route change
  useEffect(() => {
    setMissionsOpen(false);
    document.body.style.overflow = "";
  }, [location.pathname]);

  if (!visible) return null;

  const go = (path) => {
    navigate(path);
    setMissionsOpen(false);

    if (navRef.current?.classList.contains("show")) {
      navRef.current.classList.remove("show");
      document.body.style.overflow = "";
    }
  };

  return (
    <nav className="nav-top show-top">
      <div className="navbar navbar-expand-lg w-100">
        <div className="container-fluid">

          {/* LOGO */}
          <span className="navbar-brand" onClick={() => go("/")}>
            <img src={logo} className="logo" alt="logo" />
          </span>

          {/* TOGGLER */}
          <button
            className="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
            onClick={() => {
              document.body.style.overflow = "hidden";
            }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* NAV */}
          <div className="collapse navbar-collapse" id="mainNavbar" ref={navRef}>
            <ul className="navbar-nav ms-auto mobile-nav">

              <li className="nav-item">
                <button className="nav-link" onClick={() => go("/hello")}>
                  Hello!
                </button>
              </li>

              {/* MISSIONS */}
              <li className={`nav-item missions ${missionsOpen ? "open" : ""}`}>

                {/* TEXT → NAVIGATE */}
                <button
                  className="nav-link missions-label"
                  onClick={() => go("/missions")}
                >
                  Missions
                </button>

                {/* ICON → TOGGLE */}
                <button
                  className="missions-icon"
                  aria-label="Toggle missions menu"
                  onClick={() => setMissionsOpen((v) => !v)}
                >
                  <svg width="12" height="12" viewBox="0 0 24 24" color="white" fontWeight="700">
                    <path
                      d="M6 9l6 6 6-6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>

                <div className="missions-dropdown">
                  {missions.map((m) => (
                    <button
                      key={m.path}
                      className="dropdown-link"
                      onClick={() => go(m.path)}
                      style={{ fontFamily: 'MySecondFont' }}
                    >
                      {m.label}
                    </button>
                  ))}
                </div>
              </li>

              <li className="nav-item">
                <button className="nav-link" onClick={() => go("/intel")}>
                  Writings
                </button>
              </li>

              <li className="nav-item">
                <button className="nav-link" onClick={() => go("/launch")}>
                  Contact
                </button>
              </li>

            </ul>
          </div>

        </div>
      </div>
    </nav>
  );
}
